import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { mapKeys, get } from 'lodash'
import { Row, Col } from 'pui-react-grids'
import EditProfileForm from '../common/EditProfileForm'
import Footer from '../common/Footer'
import { handleSumbissionErrors } from '../form/errors'
import { updateUser } from '../actions'
import { makeAuthenticatedApi } from '../api'
import { checkUserCanSwap } from '../utils'

const styles = {
  mainCol: {
    margin: 0,
    paddingBottom: '40px',
  },
}

class EditProfile extends PureComponent {
  handleUpdateUser = userData => {
    const { districtsById } = this.props
    return this.props.api
      .updateUser({
        ...userData,
        // Bugged API O.o
        district: get(districtsById, `${userData.districtId}.nome`),
      })
      .catch(handleSumbissionErrors)
  }

  handleUpdateUserSuccess = newUserData => {
    this.props.updateUser(newUserData)
    const redirectToSwap = get(this.props.location, 'state.redirectToSwap')
    if (redirectToSwap && checkUserCanSwap(newUserData)) {
      this.props.history.push(redirectToSwap)
    } else {
      this.props.history.replace('/profile')
    }
  }

  getUserData = () => {
    return mapKeys(this.props.user, (v, k) => {
      // Fixed inconsistent API...
      if (k === 'district_id') {
        return 'districtId'
      }
      return k
    })
  }

  render() {
    return (
      <div className="padding">
        <Row>
          <Col md={3} />
          <Col md={18} style={styles.mainCol}>
            <EditProfileForm
              initialValues={this.getUserData()}
              onSubmit={this.handleUpdateUser}
              onSubmitSuccess={this.handleUpdateUserSuccess}
            />
          </Col>
          <Col md={3} />
        </Row>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  api: makeAuthenticatedApi(state),
  user: state.auth.user,
  districtsById: state.districts.byId,
})

export default connect(mapStateToProps, {
  updateUser,
})(EditProfile)



// WEBPACK FOOTER //
// ./src/pages/EditProfile.js